import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { createProveedor, getProveedor, updateProveedor } from "../../services/proveedoresService";
import "./Proveedores.css";
import notify from "../common/notify";

const ProveedorForm = ({ edit = false }) => {
  const { provId } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(edit);
  const [data, setData] = useState({
    nombre: "", contacto: "", telefono: "", email: "",
    rfc: "", direccion: "", notas: "", activo: true,
  });

  useEffect(() => {
    if (!edit) return;
    (async () => {
      const p = await getProveedor(provId);
      if (p) setData({
        nombre: p.nombre || "", contacto: p.contacto || "", telefono: p.telefono || "",
        email: p.email || "", rfc: p.rfc || "", direccion: p.direccion || "",
        notas: p.notas || "", activo: p.activo ?? true,
      });
      setLoading(false);
    })();
  }, [edit, provId]);

  const onChange = (e) => {
    const { name, value, type, checked } = e.target;
    setData((d) => ({ ...d, [name]: type === "checkbox" ? checked : value }));
  };

  const save = async () => {
    // Validación: el nombre es obligatorio (evita crear proveedores vacíos/basura).
    const nombre = (data.nombre || "").trim();
    if (!nombre) {
      notify.error("El nombre del proveedor es obligatorio.");
      return;
    }
    try {
      if (edit) {
        await updateProveedor(provId, data);
        notify.success("Proveedor actualizado");
        navigate(`/app/proveedores/${provId}`);
      } else {
        const ref = await createProveedor(data);
        notify.success("Proveedor creado");
        navigate(`/app/proveedores/${ref.id}`);
      }
    } catch (e) {
      console.error(e);
      notify.error("No se pudo guardar");
    }
  };

  if (loading) return <div className="prov-page"><div className="prov-panel">Cargando…</div></div>;

  return (
    <div className="prov-page">
      <div className="prov-panel">
        <h2>{edit ? "Editar proveedor" : "Nuevo proveedor"}</h2>

        <div className="prov-form-grid">
          <label>Nombre *
            <input name="nombre" value={data.nombre} onChange={onChange} required />
          </label>
          <label>Contacto
            <input name="contacto" value={data.contacto} onChange={onChange} />
          </label>
          <label>Teléfono
            <input name="telefono" value={data.telefono} onChange={onChange} />
          </label>
          <label>Email
            <input type="email" name="email" value={data.email} onChange={onChange} />
          </label>
          <label>RFC
            <input name="rfc" value={data.rfc} onChange={onChange} />
          </label>
          <label className="full">Dirección
            <input name="direccion" value={data.direccion} onChange={onChange} />
          </label>
          <label className="full">Notas
            <textarea name="notas" rows={3} value={data.notas} onChange={onChange} />
          </label>
          <label className="switch">
            <input type="checkbox" name="activo" checked={data.activo} onChange={onChange} />
            <span>Activo</span>
          </label>
        </div>

        <div className="prov-actions-line">
          <button
            className="btn btn-secondary"
            onClick={() => navigate("/app/proveedores")}
          >
            ← Volver a proveedores
          </button>
          <button
            className="btn btn-secondary"
            onClick={() =>
              navigate(edit ? `/app/proveedores/${provId}` : "/app/proveedores")
            }
          >
            Cancelar
          </button>
          <button className="btn btn-primary" onClick={save}>
            {edit ? "Guardar cambios" : "Crear"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ProveedorForm;
